import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Checked-square glyph for the Programming sidebar item (Figma "s-check", node
 * 16306:68615). The exported artwork is 15×14 anchored 2px down from the top of
 * the design's 16px icon box; the extra 1-unit offset (and the 18×18 viewBox)
 * keeps the ink at 16px when the sidebar renders at `fontSize: 18` — see
 * GridLayoutIcon for the full rationale.
 */
const SquareCheckIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g transform="translate(1 3)">
      <path d="M7 0.000195315C7.6 0.000195315 8 0.400195 8 1.0002C8 1.6002 7.6 2.0002 7 2.0002H2V12.0002H12V8.0002C12 7.4002 12.4 7.0002 13 7.0002C13.6 7.0002 14 7.4002 14 8.0002V13.0002C14 13.6002 13.6 14.0002 13 14.0002H1C0.4 14.0002 0 13.6002 0 13.0002V1.0002C1.32456e-08 0.400195 0.4 0.000195315 1 0.000195315H7ZM13.2998 0.3C13.6998 -0.1 14.3002 -0.1 14.7002 0.3C15.1002 0.7 15.1002 1.30039 14.7002 1.70039L7.7002 8.70039C7.5002 8.90039 7.3 9.0002 7 9.0002C6.7 9.0002 6.4998 8.90039 6.2998 8.70039L4.2998 6.70039C3.8998 6.30039 3.8998 5.7 4.2998 5.3C4.6998 4.9 5.3002 4.9 5.7002 5.3L7 6.5998L13.2998 0.3Z" />
    </g>
  </SvgIcon>
);

export default SquareCheckIcon;
